import { render, staticRenderFns } from "./EditUserProjectsModal.vue?vue&type=template&id=411b9170&scoped=true"
import script from "./EditUserProjectsModal.vue?vue&type=script&lang=js"
export * from "./EditUserProjectsModal.vue?vue&type=script&lang=js"
import style0 from "./EditUserProjectsModal.vue?vue&type=style&index=0&id=411b9170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411b9170",
  null
  
)

export default component.exports